<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
    v-if="!festivalFooter"
      :to="{path:item.url,query:{currer:0}}"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in list"
      :key="index"
    >
        <!-- <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div> -->
      <img :src="(item.url === $route.path ? item.icon2 : item.icon1)" />
      <div>{{ item.name }}</div>

    </router-link>
    <div @click="goToPage(item)" class="item" :class="{ on: item.url === $route.path }" v-if="festivalFooter" v-for="(item, index) in list" :key="index" >
      <!-- <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div> -->
      <img :src="(item.url === $route.path ? item.icon2 : item.icon1)" />
      <div>{{ item.name }}</div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "Footer",
  mounted: function () {},
  computed: {
    ...mapGetters(["footer","movieFooter","festivalFooter","bookFooter"]),
    list(){
      if (this.movieFooter) {
        return this.movieFooterList;
      } else if (this.festivalFooter) {
        return this.festivalFooterList;
      } else if (this.bookFooter) {
        return this.bookFooterList;
      } else {
        return this.footerList;
      }
    }
  },

  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          icon1: require('@/assets/images/home.png'),
          icon2: require('@/assets/images/homePlus.png'),
          url: "/"
        },
        {
          name: "分类",
          icon1: require('@/assets/images/classify.png'),
          icon2: require('@/assets/images/classfiyPlus.png'),
          url: "/category"
        },
        {
          name: "购物车",
          icon1: require('@/assets/images/cart.png'),
          icon2: require('@/assets/images/cartPlus.png'),
          url: "/cart"
        },
        {
          name: "我的",
          icon1: require('@/assets/images/user.png'),
          icon2: require('@/assets/images/userPlus.png'),
          url: "/user"
        }
      ],
      movieFooterList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/"
        },
        {
          name: "电影",
          icon1: "icon-dianying",
          icon2: "icon-dianying",
          url: "/movie"
        },
        {
          name: "影院",
          icon1: "icon-yingyuan",
          icon2: "icon-yingyuan",
          url: "/cinemas"
        },
        {
          name: "订单",
          icon1: "icon-ziyuan",
          icon2: "icon-ziyuan",
          url: "/movieOrder/0"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/user"
        }
      ],
      festivalFooterList: [
        {
          name: "首页",
          icon1: "icon-shouye-xianxing",
          icon2: "icon-shouye",
          url: "/festival/"
        }, {
          name: "购物车",
          icon1: "icon-caigou-xianxing",
          icon2: "icon-caigou",
          url: "/festivalCart"
        },
        {
          name: "我的",
          icon1: "icon-yonghu-xianxing",
          icon2: "icon-yonghu",
          url: "/festivalUser"
        }
      ],
      bookFooterList: [
        {
          name: "书城",
          icon1: require('@/assets/images/home.png'),
          icon2: require('@/assets/images/homePlus.png'),
          url: "/book"
        },
        {
          name: "分类",
          icon1: require('@/assets/images/classify.png'),
          icon2: require('@/assets/images/classfiyPlus.png'),
          url: "/bookCategory"
        },
        {
          name: "购物车",
          icon1: require('@/assets/images/cart.png'),
          icon2: require('@/assets/images/cartPlus.png'),
          url: "/bookCart"
        },
        {
          name: "我的",
          icon1: require('@/assets/images/user.png'),
          icon2: require('@/assets/images/userPlus.png'),
          url: "/bookUser"
        }
      ]
    };
  },
  watch:{},
  methods: {
    goToPage: function (item) {
      if (item.name === "首页") {
        this.$router.push({path: item.url+this.$route.query.festivalName});
      } else {
        this.$router.push({path: item.url, query: {'festivalName': this.$route.query.festivalName}});
      }
    }
  }
};
</script>
